import avatar from './avatar';
import calendar from './calendar';
import chip from './chip';
import dataTable from './data-table';
import global from './global';
import inputMask from './inputMask';
import menu from './menu';
import overlayPanel from './overlay-panel';
import skeleton from './skeleton';
import paginator from './paginator';

export default {
  avatar,
  calendar,
  chip,
  dataTable,
  global,
  inputMask,
  menu,
  overlayPanel,
  skeleton,
  paginator
};
